import { IMappingFormSettingsResponse } from 'wisestep-api';

export const isAnyFieldShown = (mappingFormSettings: IMappingFormSettingsResponse) => {
  const personalInfoSettingsFields: (keyof IMappingFormSettingsResponse)[] = [
    'name',
    'email',
    'alternateEmails',
    'phoneNumber',
    'alternatePhoneNumber',
    'passportType',
    'dob',
    'age',
    'gender',
    'postalAddress',
    'ssnNumber',
    'panCard',
    'aadharCard',
    'resume',
    'socialLinks',
    'messengerLinks',
    'skills',
    'candidatePersonalId',
  ];
  const workExpSettingsFields: (keyof IMappingFormSettingsResponse)[] = [
    'totalExperience',
    'relevantExperience',
    'jobTitle',
    'currentCompany',
    'previousJobTitles',
    'prevEmployers',
    'highestEducation',
    'institutesAttended',
    'certifications',
  ];
  const jobPreferenceSettingsFields: (keyof IMappingFormSettingsResponse)[] = [
    'jobPreference',
    'jobIncludesTravel',
    'willingToTravel',
    'relocationPreference',
    'familyWillingToRelocate',
    'noticePeriodInDays',
    'workAuthorizationCategory',
    'authorization',
    'nationality',
    'visaStatus',
    'visaValidity',
    'tags',
    'workauthorization',
    'source',
    'communicationPreference',
    'jobPreference',
    'currentJobType',
  ];
  const salaryInfoSettings: (keyof IMappingFormSettingsResponse)[] = [
    'currentSalary',
    'otherAllowance',
    'expectedSalary',
    'expectedAllowance',
  ];
  const assessmentInfoSettings: (keyof IMappingFormSettingsResponse)[] = [
    'interviewingWithOthers',
    'jobChangeReason',
    'recruiterAssessment',
  ];
  const getShowTitle = (keys: string[]) =>
    keys.map((key) => mappingFormSettings[key]).some((setting) => setting.show === true);

  return {
    showPersonalInfoSettings: getShowTitle(personalInfoSettingsFields),
    showWorkExpSettings: getShowTitle(workExpSettingsFields),
    showJobPreferenceSettings: getShowTitle(jobPreferenceSettingsFields),
    showSalaryInfoSettings: getShowTitle(salaryInfoSettings),
    showAssessmentInfoSettings: getShowTitle(assessmentInfoSettings),
  };
};
